// extracted by mini-css-extract-plugin
export default {"extra-menu-item-container":"MainApp_layouts_ExtraMenuItem_extra-menu-item-container__avyb3","extra-menu-item-title":"MainApp_layouts_ExtraMenuItem_extra-menu-item-title__08ba3"};